<script>
import PreviewElement from "./PreviewElement";
import LottieAnimationElement from "../../components/pagesbuilder/elements/LottieAnimationElement";

export default {
    name: "PreviewLottieAnimationElement",
    mixins: [PreviewElement, LottieAnimationElement],
}
</script>